export default [
    {
        "id": 1,
        "name": "Group A",
        "countries": [
            { "id": 1, "name": "Russia", "abr": "ru" },
            { "id": 2, "name": "Saudi Arabia", "abr": "sa" },
            { "id": 3, "name": "Egypt", "abr": "eh" },
            { "id": 4, "name": "Uruguay", "abr": "uy" }
        ],
        "matches": [
            {
                "id":1,
                "info": {
                    "when": "14 JUN 2018 - 18:00 Local time",
                    "stadium": "Luzhniki Stadium",
                    "city": "Moscow"
                },
                "team1": { "id": 1, "name": "Russia", "abr": "ru", "score":"" },
                "team2": { "id": 2, "name": "Saudi Arabia", "abr": "sa", "score":"" }
            },
            {
                "id":2,
                "info": {
                    "when": "14 JUN 2018 - 18:00 Local time",
                    "stadium": "Luzhniki Stadium",
                    "city": "Moscow"
                },
                "team1": { "id": 3, "name": "Egypt", "abr": "eh", "score":"" },
                "team2": { "id": 4, "name": "Uruguay", "abr": "uy", "score":"" }
            },
            {
                "id":3,
                "info": {
                    "when": "14 JUN 2018 - 18:00 Local time",
                    "stadium": "Luzhniki Stadium",
                    "city": "Moscow"
                },
                "team1": { "id": 4, "name": "Uruguay", "abr": "uy", "score":"" },
                "team2": { "id": 1, "name": "Russia", "abr": "ru", "score":"" }
            },
            {
                "id":4,
                "info": {
                    "when": "14 JUN 2018 - 18:00 Local time",
                    "stadium": "Luzhniki Stadium",
                    "city": "Moscow"
                },
                "team1": { "id": 2, "name": "Saudi Arabia", "abr": "sa", "score":"" },
                "team2": { "id": 3, "name": "Egypt", "abr": "eh", "score":"" }
            },
            {
                "id":5,
                "info": {
                    "when": "14 JUN 2018 - 18:00 Local time",
                    "stadium": "Luzhniki Stadium",
                    "city": "Moscow"
                },
                "team1": { "id": 1, "name": "Russia", "abr": "ru", "score":"" },
                "team2": { "id": 3, "name": "Egypt", "abr": "eh", "score":"" }
            },
            {
                "id":6,
                "info": {
                    "when": "14 JUN 2018 - 18:00 Local time",
                    "stadium": "Luzhniki Stadium",
                    "city": "Moscow"
                },
                "team1": { "id": 4, "name": "Uruguay", "abr": "uy", "score":"" },
                "team2": { "id": 2, "name": "Saudi Arabia", "abr": "sa", "score":"" }
            }
        ]
    },
    {
        "id": 2,
        "name": "Group B",
        "countries": [
            { "id": 1, "name": "Portugal", "abr": "pt" },
            { "id": 2, "name": "Spain", "abr": "es" },
            { "id": 3, "name": "Morocco", "abr": "ma" },
            { "id": 4, "name": "IR Iran", "abr": "ir" }
        ],
        "matches": [
            {
                "id":1,
                "info": {
                    "when": "14 JUN 2018 - 18:00 Local time",
                    "stadium": "Luzhniki Stadium",
                    "city": "Moscow"
                },
                "team1": { "id": 1, "name": "Portugal", "abr": "pt", "score":"" },
                "team2": { "id": 2, "name": "Spain", "abr": "es", "score":"" }
            },
            {
                "id":2,
                "info": {
                    "when": "14 JUN 2018 - 18:00 Local time",
                    "stadium": "Luzhniki Stadium",
                    "city": "Moscow"
                },
                "team1": { "id": 3, "name": "Morocco", "abr": "ma", "score":"" },
                "team2": { "id": 4, "name": "IR Iran", "abr": "ir", "score":"" }
            },
            {
                "id":3,
                "info": {
                    "when": "14 JUN 2018 - 18:00 Local time",
                    "stadium": "Luzhniki Stadium",
                    "city": "Moscow"
                },
                "team1": { "id": 4, "name": "IR Iran", "abr": "ir", "score":"" },
                "team2": { "id": 1, "name": "Portugal", "abr": "pt", "score":"" }
            },
            {
                "id":4,
                "info": {
                    "when": "14 JUN 2018 - 18:00 Local time",
                    "stadium": "Luzhniki Stadium",
                    "city": "Moscow"
                },
                "team1": { "id": 2, "name": "Spain", "abr": "es", "score":"" },
                "team2": { "id": 3, "name": "Morocco", "abr": "ma", "score":"" }
            },
            {
                "id":5,
                "info": {
                    "when": "14 JUN 2018 - 18:00 Local time",
                    "stadium": "Luzhniki Stadium",
                    "city": "Moscow"
                },
                "team1": { "id": 1, "name": "Portugal", "abr": "pt", "score":"" },
                "team2": { "id": 3, "name": "Morocco", "abr": "ma", "score":"" }
            },
            {
                "id":6,
                "info": {
                    "when": "14 JUN 2018 - 18:00 Local time",
                    "stadium": "Luzhniki Stadium",
                    "city": "Moscow"
                },
                "team1": { "id": 4, "name": "Uruguay", "abr": "uy", "score":"" },
                "team2": { "id": 2, "name": "Saudi Arabia", "abr": "sa", "score":"" }
            }
        ]
    },
    {
        "id": 3,
        "name": "Group C",
        "countries": [
            { "id": 1, "name": "France", "abr": "fr" },
            { "id": 2, "name": "Australia", "abr": "au" },
            { "id": 3, "name": "Peru", "abr": "pe" },
            { "id": 4, "name": "Denmark", "abr": "dk" }
        ]
    },
    {
        "id": 4,
        "name": "Group D",
        "countries": [
            { "id": 1, "name": "Argentina", "abr": "ar" },
            { "id": 2, "name": "Iceland", "abr": "is" },
            { "id": 3, "name": "Croatia", "abr": "hr" },
            { "id": 4, "name": "Nigeria", "abr": "ng" }
        ]
    },
    {
        "id": 5,
        "name": "Group E",
        "countries": [
            { "id": 1, "name": "Brazil", "abr": "br" },
            { "id": 2, "name": "Switzerland", "abr": "ch" },
            { "id": 3, "name": "Costa Rica", "abr": "cr" },
            { "id": 4, "name": "Serbia", "abr": "rs" }
        ]
    },
    {
        "id": 6,
        "name": "Group F",
        "countries": [
            { "id": 1, "name": "Germany", "abr": "de" },
            { "id": 2, "name": "Mexico", "abr": "mx" },
            { "id": 3, "name": "Sweden", "abr": "se" },
            { "id": 4, "name": "Korea Republic", "abr": "kr" }
        ]
    },
    {
        "id": 7,
        "name": "Group G",
        "countries": [
            { "id": 1, "name": "Belgium", "abr": "be" },
            { "id": 2, "name": "Pananma", "abr": "pa" },
            { "id": 3, "name": "Tunisia", "abr": "tn" },
            { "id": 4, "name": "England", "abr": "gb" }
        ]
    },
    {
        "id": 8,
        "name": "Group H",
        "countries": [
            { "id": 1, "name": "Poland", "abr": "pl" },
            { "id": 2, "name": "Senegal", "abr": "sn" },
            { "id": 3, "name": "Colombia", "abr": "co" },
            { "id": 4, "name": "Japan", "abr": "jp" }
        ]
    }
];


// WEBPACK FOOTER //
// ./src/groups.js